import type { JourneyTestNotificationRequest } from 'omega-rtc/actions/journey-test-notification';

export const getJourneyTestRecipient = (audience?: string): {
  label: string;
  type: JourneyTestNotificationRequest['recipientType'];
} | undefined => {
  switch (typeof audience === 'string' ? audience.trim().toLowerCase() : '') {
    case 'passenger':
    case 'pax': return { label: 'Pax ID', type: 'passenger' };
    case 'driver':
    case 'dax': return { label: 'Dax ID', type: 'driver' };
    case 'foodmax':
    case 'mex': return { label: 'MEX ID', type: 'foodmax' };
    default: return undefined;
  }
};

export const isSingleJourneyRecipient = (value: string): boolean => (
  Boolean(value.trim()) && !/[,\r\n]/.test(value)
);
